import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/Hero";
import { FromTo } from "./components/FromTo";
import { BeforeAfter } from "./components/BeforeAfter";
import { PainPoints } from "./components/PainPoints";
import { Volumes } from "./components/Volumes";
import { Tools } from "./components/Tools";
import { Bonuses } from "./components/Bonuses";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { Author } from "./components/Author";
import { Testimonials } from "./components/Testimonials";
import { Faq } from "./components/Faq";
import { FinalCta } from "./components/FinalCta";
import { Footer } from "./components/Footer";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="23vcmh01cjofb">
      <MetaPixel data-id="element-1" data-mp="23ti5fwt74ggi" />
      <Hero data-id="element-2" data-mp="3ik7jmqgv0tve" />
      <main data-id="element-3" data-mp="3ikqyfyb7r257">
        <FromTo data-id="element-4" data-mp="3iiwasc8k4vxf" />
        <BeforeAfter data-id="element-5" data-mp="3ijfthv617oci" />
        <PainPoints data-id="element-6" data-mp="3ii4sg33z0up3" />
        <Volumes data-id="element-7" data-mp="3mlayb9n68jv1" />
        <Tools data-id="element-8" data-mp="3mkrc3gqhn9b7" />
        <Bonuses data-id="element-9" data-mp="3mk868ye44bdj" />
        <Offer data-id="element-10" data-mp="3mjq2lgp4euvl" />
        <Guarantee data-id="element-11" data-mp="3mj6ipufwtwex" />
        <Author data-id="element-12" data-mp="3rcj6k2crlz6m" />
        <Testimonials data-id="element-13" data-mp="3rbzmaezn6ypf" />
        <Faq data-id="element-14" data-mp="3rdkgu4lyihna" />
        <FinalCta data-id="element-15" data-mp="3rd1a7k1rbfok" />
      </main>
      <Footer data-id="element-16" data-mp="5yhupa6n3cr" />
      <FloatingCta data-id="element-17" data-mp="6hr7hlrojf6" />
      <PurchasePopup data-id="element-18" data-mp="4wx1t3d72hu" />
    </div>;
}